"use client"

import type { HTMLAttributes } from "react"

import { cn } from "../lib/cn"
import { gapClasses, type Gap } from "./layout"

type StackProps = HTMLAttributes<HTMLDivElement> & {
  gap?: Gap
  align?: "start" | "center" | "end" | "stretch" | "baseline"
}

export function Stack({ gap = "sm", align, className, ...props }: StackProps) {
  return <div className={cn("flex flex-col", gapClasses[gap], { "items-start": align === "start", "items-center": align === "center", "items-end": align === "end", "items-stretch": align === "stretch", "items-baseline": align === "baseline" }, className)} {...props} />
}
